import classNames from 'classnames';
import { SortingType, SortingTypeEnum } from 'components/common/Grid/types';
import styles from './styles.module.scss';

interface ISortingArrowsProps {
  direction: SortingType
}

const SortingArrows = ({ direction }: ISortingArrowsProps) => (
  <div className={classNames(styles.arrows, { [styles.visible]: !!direction })}>
    <div className={classNames(styles.arrowUp, { [styles.active]: direction === SortingTypeEnum.ASC })} />
    <div className={classNames(styles.arrowDown, { [styles.active]: direction === SortingTypeEnum.DESC })} />
  </div>
);

export default SortingArrows;
